<template>
    <div class="flex items-center gap-2">
        <img v-if="source.logo_url" :src="source.logo_url" :alt="source.name" class="h-5 w-auto object-contain" />
        <span class="text-sm font-medium text-gray-800 dark:text-gray-100">{{ source.name }}</span>

        <span class="text-xs px-1.5 py-0.5 rounded" :class="badgeClass">
            <svg v-if="source.status === 'running'" class="inline-block animate-spin w-3 h-3 mr-1 align-text-top" fill="none" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" class="opacity-25"></circle>
                <path d="M4 12a8 8 0 018-8" stroke="currentColor" stroke-width="3" class="opacity-75"></path>
            </svg>
            {{ statusLabel }}
        </span>

        <span class="text-xs text-gray-500 dark:text-gray-400">{{ source.listings?.length || 0 }} listings</span>

        <a v-if="source.source_search_url"
           :href="source.source_search_url"
           target="_blank" rel="noopener noreferrer"
           class="text-xs text-blue-600 hover:underline dark:text-blue-400">
            View on {{ source.name }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'SourceProgress',
    props: {
        source: { type: Object, required: true },
    },
    computed: {
        statusLabel() {
            return ({
                pending: 'Pending',
                running: 'Running',
                done:    'Done',
                failed:  'Failed',
                skipped: 'Skipped',
            })[this.source.status] || this.source.status;
        },
        badgeClass() {
            return {
                'bg-gray-100 text-gray-700 dark:bg-slate-700 dark:text-gray-200':         this.source.status === 'pending',
                'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200':       this.source.status === 'running',
                'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-200':   this.source.status === 'done',
                'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-200':           this.source.status === 'failed',
                'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-200': this.source.status === 'skipped',
            };
        },
    },
};
</script>
